import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { PointsService} from '../../services/points.service';
import { RoutesService} from '../../services/routes.service';
import { RouteService} from '../../services/route.service';
import { CommonService } from '../../services/common.service';
import { NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Observable} from 'rxjs/Observable';
import {any} from "codelyzer/util/function";
import { AlertService} from '../../services/alert.service';
import swal from 'sweetalert2';
declare const google: any;
var originMarker: any;
var destinationMarker:any;
var directionsService: any;
var directionsDisplay: any;
var originLat:number;
var originLng:number;
var destinationLat:number;
var destinationLng:number;
var marker:any;
var map: any;
var cl:any;
var isLocCreated: boolean = false;
var lat:number;
var lng:number;
var isRouteCreated: boolean = false;
var idCtrlPt:any;

@Component({
  selector: 'app-controlpoint',
  templateUrl: './controlpoint.component.html',
  styleUrls: ['./controlpoint.component.css']
})
export class ControlpointComponent implements OnInit {
  pointId: any;
  pointIdSave: any;
  point: any = {};
  points: any = [];
  circles: any =[];
  pointsType: any = [];
  modalPoint: any;
  data: any = {};
  public isPtCreated = false;
  public isValid = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private routesService: RoutesService,
    private routeService: RouteService,
    private pointsService: PointsService,
    private commonService: CommonService,
    private alertService: AlertService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    marker = null;
    lat = null;
    lng = null;
    idCtrlPt=this.route.snapshot.params.idCtrlPoint;
    this.point.pointtypeId = null;
    this.getTypePoints();
    map = new google.maps.Map((<HTMLInputElement>document.getElementById('map')), {
          zoom: 7,
          center: new google.maps.LatLng(4.624335, -74.063644)
   });
   if(idCtrlPt=="-1"){
    var places = new google.maps.places.Autocomplete((<HTMLInputElement>document.getElementById('location')));
      google.maps.event.addListener(places, 'place_changed', () =>{
        var place = places.getPlace();

        var src_addr = place.formatted_address;
        var src_lat = place.geometry.location.lat();
        var src_long = place.geometry.location.lng();
        lat=src_lat;
        lng=src_long;
        //alert(lat+" "+lng);
        //alert(this.isPtCreated);
        if(this.isPtCreated==false){
           this.createPt();
        }else{
           swal({
             title: 'Ya se ha creado un punto de control, debe borrar el punto actual para generar otro.',
             text: '',
             type: 'warning',
             showCancelButton: false,
             confirmButtonColor: '#3085d6',
             cancelButtonColor: '#ff5370',
             confirmButtonText: 'Ok',
           }).then(function (s) {

           });
         }
      });
    }else if(idCtrlPt!="-1"){
      var places = new google.maps.places.Autocomplete((<HTMLInputElement>document.getElementById('location')));
        google.maps.event.addListener(places, 'place_changed', () =>{
          var place = places.getPlace();

          var src_addr = place.formatted_address;
          var src_lat = place.geometry.location.lat();
          var src_long = place.geometry.location.lng();
          lat=src_lat;
          lng=src_long;
          if(this.isPtCreated==false){
             this.createPt();
          }else{
             swal({
               title: 'Ya se ha creado un punto de control, debe borrar el punto actual para generar otro.',
               text: '',
               type: 'warning',
               showCancelButton: false,
               confirmButtonColor: '#3085d6',
               cancelButtonColor: '#ff5370',
               confirmButtonText: 'Ok',
             }).then(function (s) {

             });
           }
       });
       this.pointsService.getPointById(idCtrlPt).then(response => {
         console.log(response);
          var name=response[0].name;
          var address=response[0].address;
          var typePointId=response[0].id_pointType;
          this.point.name=name;
          this.point.address=address;
          this.point.pointtypeId=typePointId;
          this.point.Id = response[0].id;
          if(response[0].latitude!=="null"&&response[0].longitude!=="null"){
            
            lat=parseFloat(response[0].latitude);
            lng=parseFloat(response[0].longitude);
            var fColor;
            if(typePointId==1){
               fColor = '#FF0000';
            }else if(typePointId==2){
               fColor = '#800000';
            }else if(typePointId==3){
               fColor = '#FFFF00';
            }else if(typePointId==4){
               fColor = '#808000';
            }else if(typePointId==5){
               fColor = '#00FF00';
            }else if(typePointId==6){
               fColor = '#00FFFF';
            }
            var coordinate = new google.maps.LatLng(lat, lng);
            marker = new google.maps.Marker({
              position: coordinate,
              map: map,
              draggable: true
            });
            cl = new google.maps.Circle({
              strokeColor: fColor,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: fColor,
              fillOpacity: 0.35,
              center:marker.getPosition(),
              radius: 100,
              map: map
            });

            var infoWindowContent = '<div class="info_content">' +
                //'<div style="text-align:center;font-weight:bold;">'+response[0].nameType+'</div>' +
                '<p> Nombre: '+this.point.name+'</p>'
            '</div>';
            var infoWindow = new google.maps.InfoWindow({
               content: infoWindowContent
            });
            google.maps.event.addListener(marker, 'click', function() {
              infoWindow.open(map, marker);
            });
            google.maps.event.addListener(marker, 'dragend', function(marker){
              var latLng = marker.latLng;
              lat = latLng.lat();
              lng = latLng.lng();
              var coords = new google.maps.LatLng(lat, lng);
              cl.setCenter(coords);
              //alert(lat+" "+lng);
           });
           map.setZoom(15);
           map.setCenter(marker.getPosition());
           this.isPtCreated=true;
        }
       });
    }
  }
  getTypePoints():void{
    this.pointsService.getTypePoint().then(response => {
      if(response){
        this.pointsType = response;
        console.log(this.pointsType);
      }
    });
  }
  onSelectTypePointId(value):void{
    if(value!="0" || value!=null){
      this.point.pointtypeId = parseInt(value);
    }
    /*if(value!="1"){
      this.point.consecutive  = 0;
      this.point.time = 0;
      this.isDisableInput=true;
    }else{
      this.isDisableInput=false;
    }*/
  }
  createPt(){
    console.log(lat+" "+lng);
    console.log(marker);
    if (!lat || !lng) return;
      if (marker)
      {

      }
      else
      {
       if(lat!=null&&lng!=null){
        var coordinate = new google.maps.LatLng(lat, lng);
        var infoWindowContent = '<div class="info_content">' +
            '<p> Nombre: '+this.point.name+'</p>' +
        '</div>';
        var infoWindow = new google.maps.InfoWindow({
           content: infoWindowContent
        });
        marker = new google.maps.Marker({
          position: coordinate,
          map: map,
          draggable: true
        });
        cl = new google.maps.Circle({
          strokeColor: '#87CEFA',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#87CEFA',
          fillOpacity: 0.35,
          center:marker.getPosition(),
          radius: 100,
          map: map
        });
        google.maps.event.addListener(marker, 'click', function() {
          infoWindow.open(map, marker);
        });
        google.maps.event.addListener(marker, 'dragend', function(marker){
          var latLng = marker.latLng;
          lat = latLng.lat();
          lng = latLng.lng();
          var coords = new google.maps.LatLng(lat, lng);
          cl.setCenter(coords);
       });
       map.setZoom(15);
       map.setCenter(marker.getPosition());
       this.isPtCreated=true;
      }
     }
  }
  erasePt(){
    if(this.isPtCreated){
      let that = this;
      swal({
        title: '¿Esta seguro de borrar el punto de control creado?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No'
      }).then(function (s) {
        console.log(s);
       if(s.dismiss !== undefined){
         if (s.dismiss.toString() === 'cancel') {
         }
       }else{
         if(s.value!== undefined){
            if(s.value){
              marker.setMap(null);
              marker=null;
              cl.setMap(null);
              cl=null;
              that.isPtCreated=false;
              that.point.name=" ";
              that.point.address=" ";
              that.point.location="";
              that.point.pointtypeId = null;
              lat=null;
              lng=null;
            }
         }
       }
     }).catch(swal.noop);
   }else{
     swal({
       title: "Aún no se ha creado un punto de control.",
       text: '',
       type: 'warning'
      }).catch(swal.noop);
   }
  }
  savePt(){
    if(this.point.pointtypeId!=null){
        if(parseInt(this.point.pointtypeId)!=0){
            this.isValid=true;
            var s="";
            if(this.point.name ==null || this.point.name == ""){
              this.isValid=false;
              s=s+"El nombre es requerido";
            }
            if(this.point.address == null || this.point.address == ""){
              if(this.isValid==false){
                s=s+", la dirección es requerida";
              }else{
                  s=s+"La dirección es requerida";
              }
              this.isValid=false;

            }
            if(this.isValid){
              if(this.isPtCreated){
                  let that = this;
                  swal({
                    title: '¿Esta seguro de guardar el punto de control creado?',
                    text: '',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sí',
                    cancelButtonText: 'No'
                  }).then(function (s) {
                    if(s.dismiss !== undefined){
                      if (s.dismiss.toString() === 'cancel') {
                      }
                    }else{
                      if(s.value!== undefined){
                        if(s.value){
                          var name=that.point.name;
                          var address=that.point.address;
                          var pointtypeId = that.point.pointtypeId;
                          var param;
                          if(that.point.Id != null){
                            param = {
                                      "Id": that.point.Id,
                                      "User_account":that.commonService.getUserName(),
                                      "IdTypePoint":pointtypeId,
                                      "Name" : String(name),
                                      "Address" : String(address),
                                      "Latitude" : String(lat),
                                      "Longitude": String(lng)
                            };
                          }else{
                            param = {
                                      "User_account":that.commonService.getUserName(),
                                      "IdTypePoint":pointtypeId,
                                      "Name" : String(name),
                                      "Address" : String(address),
                                      "Latitude" : String(lat),
                                      "Longitude": String(lng)
                            };
                          }

                          console.log(param);
                          that.pointsService.saveUpdatePoint(param)
                            .then(response =>{
                              if (response.status == 'EXITO') {
                                var fColor;
                                if(pointtypeId==1){
                                   fColor = '#FF0000';
                                }else if(pointtypeId==2){
                                   fColor = '#800000';
                                }else if(pointtypeId==3){
                                   fColor = '#FFFF00';
                                }else if(pointtypeId==4){
                                   fColor = '#808000';
                                }else if(pointtypeId==5){
                                   fColor = '#00FF00';
                                }else if(pointtypeId==6){
                                   fColor = '#00FFFF';
                                }
                                var coordinate = new google.maps.LatLng(lat, lng);
                                var circle = new google.maps.Circle({
                                   strokeColor: fColor,
                                   strokeOpacity: 0.8,
                                   strokeWeight: 2,
                                   fillColor: fColor,
                                   fillOpacity: 0.35,
                                   center:coordinate,
                                   radius: 100,
                                   map: map
                                 });
                                console.log(circle);
                                var infoWindowContent = '<div class="info_content">' +
                                    '<p>'+name+'</p>' +
                                '</div>';
                                circle.info = new google.maps.InfoWindow({
                                   content: infoWindowContent
                                });
                                google.maps.event.addListener(circle, 'click', function() {
                                  this.info.setPosition(this.getCenter());
                                  this.info.open(map, this);
                                });

                                circle.mID = response.lastId;
                                that.circles.push({id:response.lastId, circle:circle});
                                cl.setMap(null);
                                cl=null;
                                marker.setMap(null);
                                marker=null;
                                lat=null;
                                lng=null;
                                that.isPtCreated=false;
                                that.point.name = null;
                                that.point.address=null;
                                that.point.location="";
                                that.point.pointtypeId = null;
                                that.point.Id = null;
                                that.router.navigate(['/home/controlpoints']);
                              }
                            });
                        }
                      }  
                    }
                 }).catch(swal.noop);
              }else{
                swal({
                  title: "Debe de crear un punto de control para poder guardar.",
                  text: '',
                  type: 'warning'
                 }).catch(swal.noop);
              }
            }else{
              swal({
                title: s,
                text: '',
                type: 'warning'
               }).catch(swal.noop);
            }
          }else{
            swal({
              title: "Debe seleccionar un tipo de punto.",
              text: '',
              type: 'warning'
             }).catch(swal.noop);
          }
      }else{
        swal({
          title: "Debe seleccionar un tipo de punto.",
          text: '',
          type: 'warning'
         }).catch(swal.noop);
      }
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/controlpoint/controlpoint.component.ts